import {
  defaultKeywordResponses,
  defaultKeywordStatuses,
  starterSuggestions,
} from './mockConversations.js'

const STORAGE_KEY = 'proapp-intelligence-settings'

const clone = (value) => JSON.parse(JSON.stringify(value))

export const getDefaultIntelligenceSettings = () => ({
  suggestions: clone(starterSuggestions),
  keywordResponses: clone(defaultKeywordResponses),
  keywordStatuses: clone(defaultKeywordStatuses),
})

const normalizeStatuses = (statuses, defaults) => {
  if (!Array.isArray(statuses)) return clone(defaults)

  const normalizedStatuses = statuses
    .map((status) => String(status || '').trim())
    .filter(Boolean)

  return normalizedStatuses.length ? normalizedStatuses : clone(defaults)
}

const normalizeSettings = (storedSettings) => {
  const defaults = getDefaultIntelligenceSettings()
  const source =
    storedSettings && typeof storedSettings === 'object' ? storedSettings : {}
  const storedSuggestions = Array.isArray(source.suggestions)
    ? source.suggestions
    : []

  const suggestions = defaults.suggestions.map((suggestion) => {
    const storedSuggestion = storedSuggestions.find(
      (item) => item && item.id === suggestion.id,
    )

    if (!storedSuggestion) return suggestion

    return {
      ...suggestion,
      prompt: String(storedSuggestion.prompt || '').trim() || suggestion.prompt,
      response:
        String(storedSuggestion.response || '').trim() || suggestion.response,
      statuses: normalizeStatuses(storedSuggestion.statuses, suggestion.statuses),
    }
  })

  const keywordResponses = Array.isArray(source.keywordResponses)
    ? source.keywordResponses.map((item, index) => {
        const storedItem = item && typeof item === 'object' ? item : {}

        return {
          id: String(storedItem.id || `keyword-${index + 1}`),
          keyword: String(storedItem.keyword || ''),
          response: String(storedItem.response || ''),
        }
      })
    : defaults.keywordResponses

  const keywordStatuses = normalizeStatuses(
    source.keywordStatuses,
    defaults.keywordStatuses,
  )

  return {suggestions, keywordResponses, keywordStatuses}
}

export const loadIntelligenceSettings = () => {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY)
    return value
      ? normalizeSettings(JSON.parse(value))
      : getDefaultIntelligenceSettings()
  } catch (error) {
    return getDefaultIntelligenceSettings()
  }
}

export const saveIntelligenceSettings = (settings) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(settings))
  } catch (error) {
    // Keep the editor functional when browser storage is unavailable.
  }
}
